import { ThunkDispatch } from "redux-thunk";

import createValueModule from "@/redux/create-value-module";
import { IState, TExtraThunkArgs, TValueAction } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import {
    $StickyActionsModuleName,
    TStickyActionsState
} from "./stickyActions.types";

const { constants: _constants, actions } =
    createValueModule<TStickyActionsState>($StickyActionsModuleName, {
        references: 0
    });

const updateReferences =
    (count: number) =>
    async (
        dispatch: ThunkDispatch<IState, TExtraThunkArgs, TValueAction>,
        getState: () => IState
    ) => {
        const currentReferences =
            getValueState(getState(), $StickyActionsModuleName)?.references ??
            0;

        const { payload } = dispatch(
            set({
                references: Math.max(0, currentReferences + count)
            })
        );

        return payload?.references ?? 0;
    };

export const addReference = () => updateReferences(1);

export const removeReference = () => updateReferences(-1);

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
